import { useTranslation } from "react-i18next"
import { ReadOnlyFormField } from "@/modules/patients/detail/health-information/readonly-form-field"
import { GynaecologyFragment$data } from "@/modules/patients/services/__generated__/GynaecologyFragment.graphql"
import { PregnancyStatus } from "@/types/__generated__/union-types"

interface GynaecologyReadonlyBodyProps {
  dataView: GynaecologyFragment$data
}

const GynaecologyReadonlyBody = ({ dataView }: GynaecologyReadonlyBodyProps) => {
  const { t } = useTranslation()

  const pregnantStatusView = (pregnancyStatus?: PregnancyStatus): string => {
    switch (pregnancyStatus) {
      case "PREGNANT":
        return t("common.yes")
      case "NOT_PREGNANT":
        return t("common.no")

      case "UNKNOWN":
      case undefined:
        return t("patient.healthInformation.medication.options.NOT_ENQUIRED")
    }
  }

  return (
    <div className="grid grid-cols-4 gap-4">
      <div className="col-span-2">
        <ReadOnlyFormField
          label={t("patient.healthInformation.gynaecology.form.firstPeriod")}
          dataTestId="first-period">
          {dataView.firstPeriod || "-"}
        </ReadOnlyFormField>
      </div>

      <div className="col-span-2">
        <ReadOnlyFormField
          label={t("patient.healthInformation.gynaecology.form.menopauseSince")}
          dataTestId="menopause-since">
          {dataView.menopauseSince || "-"}
        </ReadOnlyFormField>
      </div>

      {!dataView.menopauseSince && (
        <>
          <div className="col-span-2">
            <ReadOnlyFormField
              label={t("patient.healthInformation.gynaecology.form.currentlyPregnant")}
              dataTestId="currently-pregnant">
              {pregnantStatusView(dataView.pregnancy)}
            </ReadOnlyFormField>
          </div>
          {dataView.pregnancy === "PREGNANT" && (
            <div className="col-span-2">
              <ReadOnlyFormField
                label={t("patient.healthInformation.gynaecology.form.weekOfPregnancy")}
                dataTestId="week-of-pregnancy">
                {dataView.weeksOfPregnancy}
              </ReadOnlyFormField>
            </div>
          )}
        </>
      )}

      <div className="col-span-4">
        <ReadOnlyFormField
          label={t("patient.healthInformation.gynaecology.form.pregnancyHistory")}
          dataTestId="pregnancy-history">
          {dataView.pregnancyHistory || "-"}
        </ReadOnlyFormField>
      </div>
    </div>
  )
}

export { GynaecologyReadonlyBody }
